<template>
  <div class="component-card">
    <j-title-header :options="title"/>

    <b-form-group :class="{'error-input' : $v.data_master.id.$error}">
      <label> ID </label>
      <j-input
        v-model="$v.data_master.id.$model"
        :disabled="true"
        placeholder="ID"/>
    </b-form-group>

    <b-form-group :class="{'error-input' : $v.data_master.category_name.$error}">
      <label> Category Name </label>
      <j-input
        v-model="$v.data_master.category_name.$model"
        :disabled="true"
        placeholder="Category Name"/>
    </b-form-group>

    <b-form-group :class="{'error-input' : $v.data_master.status.$error}">
      <label> Status </label>
      <j-input
        v-model="$v.data_master.status.$model"
        :disabled="true"
        placeholder="Status"/>
    </b-form-group>

    <b-form-group :class="{'error-input' : $v.data_master.nis.$error}">
      <label> NIS </label>
      <j-input
        v-model="$v.data_master.nis.$model"
        :disabled="true"
        placeholder="NIS"/>
    </b-form-group>

    <b-form-group :class="{'error-input' : $v.data_master.name.$error}">
      <label> Nama Siswa </label>
      <j-input
        v-model="$v.data_master.name.$model"
        :disabled="true"
        placeholder="Nama Siswa"/>
    </b-form-group>

    <b-form-group :class="{'error-input' : $v.data_master.title.$error}">
      <label> Title </label>
      <j-input
        v-model="$v.data_master.title.$model"
        :disabled="true"
        placeholder="Title"/>
    </b-form-group>

    <b-form-group :class="{'error-input' : $v.data_master.attachment.$error}">
      <label> Attachment </label>
      <j-upload-file
        v-if="showAdditionalInfo"
        v-model="$v.data_master.attachment.$model"
        :accepted-file-type="['pdf']"
        :api-token="token"
        :img-default="$v.data_master.attachment.$model"
        :name-default="fileNameDefault"
        :url-upload="url_upload"
        :disabled="true"
        @url="getUrl"/>
    </b-form-group>

    <!-- <b-form-group :class="{'error-input' : $v.data_master.attachment.$error}">
      <label> File </label><br>
      <j-singleupload
        v-model="$v.data_master.attachment.$model"
        :accepted-file-type="['pdf']"
        :api-token="token"
        :img-default="$v.data_master.attachment.$model"
        :url-upload="url_upload"
        :disabled="true"
        @url="getUrl"/>
    </b-form-group> -->

    <j-form-base
      v-if="showAdditionalInfo"
      ref="jFormUpdate"
      :data-fields="dataFields"
      :is-detail="true"
      :is-disabled="true"/>

    <b-row>
      <b-col md="3">
        <b-button
          class="btn gray"
          @click="$router.replace('/buku-saku-siswa/approver')">
          Cancel
        </b-button>
      </b-col>
      <b-col md="9">
        <div
          v-if="this.$route.params.status === 'sent'"
          class="float-to-right">
          <b-button
            class="btn blue m__r--5"
            @click="approveData">
            Approve
          </b-button>
          <b-button
            class="btn red m__r--5"
            @click="rejectData">
            Reject
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import jFormBase from '@/views/kurikulum/additional-info/jFormBase';
import jUploadFile from '@/components/upload-file/jUploadFile';

export default {
  components: {
    jFormBase,
    jUploadFile,
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Buku Saku Siswa',
      },
      data_master: {
        id: 0,
        category_name: '',
        status: '',
        nis: '',
        anme: '',
        title: '',
        attachment: null,
        additional_info: [],
      },
      token: (JSON.parse(localStorage.getItem('Token'))).value,
      dataFields: [],
      showAdditionalInfo: false,
      fileNameDefault: '',
    };
  },
  computed: {
    url_upload() {
      return `${process.env.GATE_URL}file/upload`;
    },
  },
  watch: {
  },
  created() {
    this.getDetailData();
  },
  methods: {
    ...mapActions('jStoreKesiswaan', ['detailDocument', 'getListSiswa', 'approveDocument', 'rejectDocument']),

    getUrl(data) {
      this.data_master.attachment = data;
    },

    getDetailData() {
      const params = {
        id: this.$route.params.id,
      };
      this.detailDocument(params).then((res) => {
        const paramSiswa = {
          pagination: {
            query: res.data.data.nis,
            query_type: 'nis',
          },
        };
        this.getListSiswa(paramSiswa).then((resSiswa) => {
          const dataSiswa = resSiswa.data.data[0];

          this.data_master = {
            id: this.$route.params.id,
            category_name: res.data.data.category_name,
            status: res.data.data.status,
            nis: dataSiswa.nis,
            name: dataSiswa.nama_siswa,
            title: res.data.data.title,
            attachment: res.data.data.attachment,
            additional_info: [],
          };
          this.dataFields = res.data.data.additional_info.map(el => ({
            id: el.id,
            name: el.field_name,
            type: el.type,
            placeholder: el.placeholder,
            field_key: el.field_key,
            value: el.value,
            is_delete: false,
            is_editable: false,
            is_mandatory: false,
          }));
          this.fileNameDefault = res.data.data.attachment_name || '-';
          this.showAdditionalInfo = true;
        });
      });
    },

    approveData() {
      this.$swal({
        title: 'Approve Data',
        text: 'Are you sure want to approve this data?',
        input: 'text',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Approve',
      }).then((result) => {
        const param = {
          id: this.data_master.id,
          note: result.value,
        };
        this.approveDocument(param).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$router.replace('/buku-saku-siswa/approver');
            }, 1500);
          }
        });
      });
    },

    rejectData() {
      this.$swal({
        title: 'Reject Data',
        text: 'Are you sure want to reject this data?',
        showCancelButton: true,
        confirmButtonText: 'Reject',
      }).then((result) => {
        const param = {
          id: this.data_master.id,
        };
        this.rejectDocument(param).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$router.replace('/buku-saku-siswa/approver');
            }, 1500);
          }
        });
      });
    },
  },
  validations() {
    return {
      data_master: {
        id: { },
        category_name: { },
        status: { },
        nis: { },
        name: { },
        type: { },
        title: { },
        attachment: { },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/buku-saku/approver/jBukuSakuFormApp.vue